import { render } from "./AccountsPayableInvoice.vue?vue&type=template&id=02b33da2&scoped=true"
import script from "./AccountsPayableInvoice.vue?vue&type=script&lang=js"
export * from "./AccountsPayableInvoice.vue?vue&type=script&lang=js"

import "./AccountsPayableInvoice.vue?vue&type=style&index=0&id=02b33da2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b33da2"]])

export default __exports__